var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.18294 9.11484C8.6385 9.11484 8.16905 8.92154 7.77461 8.53494C7.38017 8.14834 7.18294 7.6789 7.18294 7.12661C7.18294 6.57432 7.37739 6.10096 7.76628 5.70651C8.15517 5.31207 8.62739 5.11484 9.18294 5.11484C9.7385 5.11484 10.2107 5.31091 10.5996 5.70304C10.9885 6.09517 11.1829 6.57132 11.1829 7.13151C11.1829 7.68243 10.9885 8.15072 10.5996 8.53638C10.2107 8.92202 9.7385 9.11484 9.18294 9.11484ZM2.73294 11.7815V2.46484H15.6496V11.7815H2.73294ZM5.71628 10.4482H12.6663C12.6663 9.99262 12.8247 9.60651 13.1417 9.28984C13.4586 8.97318 13.8502 8.81484 14.3163 8.81484V5.44818C13.8496 5.44818 13.4579 5.28446 13.1413 4.95703C12.8246 4.62959 12.6663 4.24331 12.6663 3.79818H5.71628C5.71628 4.24262 5.55534 4.62873 5.23346 4.95651C4.91158 5.28429 4.52252 5.44818 4.06628 5.44818V8.81484C4.52183 8.81484 4.91072 8.97415 5.23294 9.29276C5.55517 9.61137 5.71628 9.99651 5.71628 10.4482ZM0.349609 14.1648V5.23151H1.86628V12.6482H13.2663V14.1648H0.349609Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlPriceIcon);
export default __webpack_public_path__ + "static/media/bl-price-icon.db67bbb8a1262db48f9692be43175c9f.svg";
export { ForwardRef as ReactComponent };